/**
 * Elemek kivágása, és visszaadása.
 * @param el - Elem.
 */
export default function cutChildNodes (el: HTMLElement): DocumentFragment {
  const frag = document.createDocumentFragment()

  /* oxlint-disable eslint-js/no-restricted-properties -- Itt használható a firstChild */
  while (el.firstChild) {
    frag.appendChild(el.firstChild)
  }
  /* oxlint-enable eslint-js/no-restricted-properties */

  return frag
}
